export default "__VITE_ASSET__B8AWvK$L__"